export default __webpack_public_path__ + "static/media/1.4a1ff45d.jpg";